var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCatalogue = function SvgIconCatalogue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 11,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    y: 0.506,
    fill: "currentColor",
    rx: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 4,
    y: 0.506,
    fill: "currentColor",
    rx: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 8,
    y: 0.506,
    fill: "currentColor",
    rx: 1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    y: 4.506,
    fill: "currentColor",
    rx: 1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 4,
    y: 4.506,
    fill: "currentColor",
    rx: 1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 8,
    y: 4.506,
    fill: "currentColor",
    rx: 1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    y: 8.506,
    fill: "currentColor",
    rx: 1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 4,
    y: 8.506,
    fill: "currentColor",
    rx: 1
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 8,
    y: 8.506,
    fill: "currentColor",
    rx: 1
  })));
};
export { SvgIconCatalogue as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTEiIHZpZXdCb3g9IjAgMCAxMCAxMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeT0iMC41MDU4NTkiIHdpZHRoPSIyIiBoZWlnaHQ9IjIiIHJ4PSIxIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPHJlY3QgeD0iNCIgeT0iMC41MDU4NTkiIHdpZHRoPSIyIiBoZWlnaHQ9IjIiIHJ4PSIxIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPHJlY3QgeD0iOCIgeT0iMC41MDU4NTkiIHdpZHRoPSIyIiBoZWlnaHQ9IjIiIHJ4PSIxIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPHJlY3QgeT0iNC41MDU4NiIgd2lkdGg9IjIiIGhlaWdodD0iMiIgcng9IjEiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8cmVjdCB4PSI0IiB5PSI0LjUwNTg2IiB3aWR0aD0iMiIgaGVpZ2h0PSIyIiByeD0iMSIgZmlsbD0iY3VycmVudENvbG9yIi8+CjxyZWN0IHg9IjgiIHk9IjQuNTA1ODYiIHdpZHRoPSIyIiBoZWlnaHQ9IjIiIHJ4PSIxIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPHJlY3QgeT0iOC41MDU4NiIgd2lkdGg9IjIiIGhlaWdodD0iMiIgcng9IjEiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8cmVjdCB4PSI0IiB5PSI4LjUwNTg2IiB3aWR0aD0iMiIgaGVpZ2h0PSIyIiByeD0iMSIgZmlsbD0iY3VycmVudENvbG9yIi8+CjxyZWN0IHg9IjgiIHk9IjguNTA1ODYiIHdpZHRoPSIyIiBoZWlnaHQ9IjIiIHJ4PSIxIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";